<div
  data-test-id="phone-verification"
  class="flex flex-col items-center w-full m-auto px-6 py-8 lg:py-11 md:max-w-[70%]">
  <div>
    <bey-otp
      (onResendClick)="onClickResend()"
      (onCodeChange)="onChange($event)"
      [isLoading$]="verifyVerificationCodeIsLoading$"></bey-otp>
  </div>
</div>
